import { Button } from "@/components/ui/button";
import { useAuthState } from "@/modules/auth/presentation/model/useAuthState";
import { Link } from "@tanstack/react-router";
import { DatabaseBackup, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useBackupStatusQuery } from "../api/queries";

const DISMISS_KEY = "mineral-backup-banner-dismissed-at";

function isDismissedForSession(): boolean {
  try {
    return sessionStorage.getItem(DISMISS_KEY) === "1";
  } catch {
    return false;
  }
}

export function BackupReminderBanner() {
  const { hasPermission, isAuthenticated } = useAuthState();
  const canBackup = isAuthenticated && hasPermission("system:backup");
  const { data: status } = useBackupStatusQuery(canBackup);
  const [dismissed, setDismissed] = useState(isDismissedForSession);

  useEffect(() => {
    if (!status?.due) {
      try {
        sessionStorage.removeItem(DISMISS_KEY);
      } catch {
        /* ignore */
      }
      setDismissed(false);
    }
  }, [status?.due]);

  if (!canBackup || !status?.due || dismissed) {
    return null;
  }

  const hideForNow = () => {
    try {
      sessionStorage.setItem(DISMISS_KEY, "1");
    } catch {
      /* ignore */
    }
    setDismissed(true);
  };

  return (
    <div
      role="alert"
      className="border-b border-amber-500/40 bg-amber-500/15 px-4 py-3 text-amber-950 dark:text-amber-50"
    >
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3">
        <div className="flex min-w-0 items-start gap-3">
          <DatabaseBackup className="mt-0.5 size-5 shrink-0" aria-hidden />
          <div className="min-w-0">
            <p className="font-medium">ເຖິງເວລາສຳຮອງຂໍ້ມູນ PostgreSQL</p>
            <p className="text-sm opacity-90">{status.messageLo}</p>
          </div>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <Button size="sm" variant="secondary" asChild>
            <Link to="/app/system/backup">ໄປໜ້າ backup</Link>
          </Button>
          <Button
            size="icon"
            variant="ghost"
            className="size-8"
            onClick={hideForNow}
            aria-label="ປິດແຈ້ງເຕືອນຊົ່ວຄາວ"
          >
            <X className="size-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
